const DATA_TYPE = {
  Absensi: "Absensi",
  Akun: "Akun",
  AkunBaru: "Akun Baru",
  Anggaran: "Anggaran",
  DokumenTransaksi: "Dokumen Transaksi",
  GrupTransaksi: "Grup Transaksi",
  Realokasi: "Realokasi",
  RencanaImplementasi: "Rencana Implementasi",
  SystemLog: "System Log",
  Transaksi: "Transaksi",
  UMK: "UMK",
  UMO: "UMO",
  UnitKerja: "Unit Kerja",
};
export default DATA_TYPE;
